import {
  Box,
  Button,
  Image,
  Layer,
  Markdown,
  ResponsiveContext,
  Text
} from 'grommet'
import YoutubeEmbed from './content/YoutubeEmbed';

const InducteeModal = (props) => {
  const { category, inductee, year, t } = props;

  const renderCategoryImage = (float) => {
    if (
      category.fields.hasOwnProperty('imageSmall')
      && category.fields.image
    ){
      return (
        <img
          className={float ? "categoryImage categoryImageFloat" : "categoryImage"}
          //fit="contain"
          //fill={false}
          src={category.fields.imageSmall.fields.file.url}
        />
      )
    } else {
      return (
        <p>No category image</p>
      )
    }
  }

  const renderInducteeImage = () => {
    if (
      inductee.fields.hasOwnProperty('image')
    ){
      return (
        <img
          className="inducteeImage"
          src={inductee.fields.image.fields.file.url}
        />
      )
    } else {
      return (
        <p>No inductee image</p>
      )
    }
  }

  const renderInducteeName = () => {
    if (
      inductee.fields.hasOwnProperty('year')
    ){
      return (
        <h3>{inductee.fields.year}</h3>
      )
    } else {
      return null;
    }
  }

  const renderInducteeSpecs = () => {
    if (
      inductee.fields.hasOwnProperty('specs')
    ){
      return (
        <Box
          className="specs"
          direction="row"
          justify="stretch"
        >
          { inductee.fields.specs.map( (spec, index) => {
            return (
              <Box className="spec" flex="grow" key={index}>
                <h4 className="specTitle">{spec.fields.title}</h4>
                <div className="specValue">{spec.fields.value}</div>
              </Box>
            )
          })}
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeShortDescription = () => {
    if (
      inductee.fields.hasOwnProperty('shortDescription')
    ){
      return (
        <p className="shortDescription">{inductee.fields.shortDescription}</p>
      )
    } else {
      return null
    }
  }

  const renderInducteeLongDescription = () => {
    if (
      inductee.fields.hasOwnProperty('longDescription')
    ){
      return (
        <Box className="longDescription">
          <Markdown
            components={{
              "p": {
                "component": "Paragraph",
                "props": {"size": "medium"}
              }
            }}
          >{inductee.fields.longDescription }</Markdown>
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeVideo = () => {
    if (
      inductee.fields.hasOwnProperty('videoId')
      && inductee.fields.videoId
    ){
      return (
        <Box className="video">
          <YoutubeEmbed embedId={inductee.fields.videoId} />
        </Box>
      )
    } else {
      return null
    }
  }

  const renderInducteeCTA = () => {
    if (
      inductee.fields.hasOwnProperty('cta01')
      && inductee.fields.cta01
      && inductee.fields.hasOwnProperty('ctaLink')
      && inductee.fields.ctaLink
    ){
      return (
        <Box className="ctaWrapper" pad="medium" justify="center" align="center">
          <Button
            primary
            href={inductee.fields.ctaLink}
            label={inductee.fields.cta01}
          />
        </Box>
      )
    } else {
      return null
    }
  }

  return (
    <Box className="popupInductee">
      <Box flex={{grow: 0,shrink: 1}} className="header">
        {renderCategoryImage()}
        {renderInducteeImage()}
        <div className="inducteeLabel">{t('inductee')}</div>
        {renderInducteeName()}
      </Box>
      <Box flex={{grow: 1, shrink: 0}} className="body">
        {renderInducteeShortDescription()}
        {renderInducteeSpecs()}
        {renderInducteeCTA()}
        {renderInducteeVideo()}
        {renderInducteeLongDescription()}
      </Box>
    </Box>
  );
};

export default InducteeModal;
